<div class="backend-status-banner" *ngIf="isBackendDown$ | async">
  <span class="backend-status-banner__spinner"></span>
  <span i18n="@@backend_connection_lost">Connection to the server lost.</span>
  <a
    class="backend-status-banner__retry"
    (click)="retry()"
    i18n="@@retry_connection"
    >Click to retry</a
  >
</div>
